import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import promotionalCodeAction from 'actions/promotionalCodeAction';
import productsActions from 'actions/productsActions';
import preLoaderActions from 'actions/preLoaderActions';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { PromotionalCode } from './promotionalCode';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        promoCode: state.promotionalCode,
        initialStep: state.initialStep,
        products: state.products,
    };
};
const mapDispatchToProps = dispatch => ({
    promotionalCodeAction: bindActionCreators(promotionalCodeAction, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    productsActions: bindActionCreators(productsActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
});

export const PromotionalCodeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(withFeatureToggling(PromotionalCode));
